import { Text, TextProps } from '@mantine/core'
import { useTranslate } from 'react-admin'

type LXNoDataProps = TextProps

const defaultProps: TextProps = {
  fw: 300,
  fs: 'italic',
  ta: 'center',
  c: 'grey',
  mx: 'auto',
  my: 'xl',
}

export const LXNoData = (props: LXNoDataProps) => {
  const translate = useTranslate()

  return (
    <Text {...defaultProps} {...props}>
      {translate('_generics.noData')}
    </Text>
  )
}
